import fetch from '~~/common/js/universal/fetch';

const { getSearchFeedbackProxiedURL } = require('~~/search/common/js/universal/proxy/search-feedback');

const fetchProxy = ({ url, proxyUrl, shouldProxy = false }) => {
  if (shouldProxy) {
    // if the try with proxied url fails for any reason, we try again with the normal url,
    // also returning the catch for thrown errors to bubble up to be logged by sentry.
    return fetch(getSearchFeedbackProxiedURL({ url, proxyUrl, shouldProxy }))
      .catch(async () => fetch(url));
  }

  return fetch(url);
};

export const trackPageLoad = ({ url, proxyUrl, shouldProxy = false }) => {
  fetchProxy({ url, proxyUrl, shouldProxy });

  const handler = () => {
    if (!document.hidden) {
      fetchProxy({ url, proxyUrl, shouldProxy });
    }
  };

  document?.addEventListener('visibilitychange', handler, false);
};

export const trackAdClick = ({ url, suffix, shouldProxy = false, proxyUrl }) => fetchProxy({ url: `${url}${suffix}`, shouldProxy, proxyUrl });
